var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 5.14706H16.6668M8.3335 13.9706V8.67647M11.6668 13.9706V8.67647M13.3335 17.5H6.66683C5.74636 17.5 5.00016 16.7099 5.00016 15.7353V6.02941C5.00016 5.5421 5.37326 5.14706 5.8335 5.14706H14.1668C14.6271 5.14706 15.0002 5.5421 15.0002 6.02941V15.7353C15.0002 16.7099 14.254 17.5 13.3335 17.5ZM8.3335 5.14706H11.6668C12.1271 5.14706 12.5002 4.75202 12.5002 4.26471V3.38235C12.5002 2.89504 12.1271 2.5 11.6668 2.5H8.3335C7.87326 2.5 7.50016 2.89504 7.50016 3.38235V4.26471C7.50016 4.75202 7.87326 5.14706 8.3335 5.14706Z",
    stroke: "#212330",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioTrashIcon);
export default __webpack_public_path__ + "static/media/portfolioTrashIcon.0b86b6001e22778ef1726d847edea966.svg";
export { ForwardRef as ReactComponent };